import { __assign, __rest } from "tslib";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { createRocket } from "../_util/create-rocket";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { Justify } from "../justify";
import { useConfig } from "../_util/config-context";
import { H3 } from "../heading";
var CardHeader = createRocket("CardHeader", "div.@{prefix}-card__header");
var CardFooter = createRocket("CardFooter", "div.@{prefix}-card__footer");
var CardBody = forwardRef(function (props, ref) {
    var classPrefix = useConfig().classPrefix;
    var className = props.className, style = props.style, title = props.title, subtitle = props.subtitle, operation = props.operation, children = props.children;
    return (React.createElement("div", { ref: ref, className: classNames(classPrefix + "-card__body", className), style: style },
        (title || subtitle || operation) && (React.createElement("div", { className: classPrefix + "-card__title" },
            React.createElement(Justify, { left: React.createElement(H3, null,
                    title,
                    subtitle && (React.createElement("span", { className: classPrefix + "-card__subtitle" }, subtitle))), right: operation }))),
        React.createElement("div", { className: classPrefix + "-card__content" }, children)));
});
CardBody.displayName = "CardBody";
export var Card = forwardRefWithStatics(function (_a, ref) {
    var _b;
    var className = _a.className, children = _a.children, bordered = _a.bordered, full = _a.full, props = __rest(_a, ["className", "children", "bordered", "full"]);
    var classPrefix = useConfig().classPrefix;
    var cardClassName = classNames(classPrefix + "-card", (_b = {},
        _b[classPrefix + "-card--bordered"] = bordered,
        _b[classPrefix + "-card--full"] = full === true,
        _b[classPrefix + "-card--full-with-header"] = full === "withHeader",
        _b), className);
    return (React.createElement("div", __assign({ ref: ref, className: cardClassName }, props), children));
}, 
// Card statics
{
    Header: CardHeader,
    Body: CardBody,
    Footer: CardFooter,
});
Card.displayName = "Card";
//# sourceMappingURL=Card.js.map